import { isNumeric } from './number';

/**
 * Handle numeric string input safely.
 */
export const safeNumericString = (input: string) => isNumeric(input) ? Number(input) : '';
/**
 * Handle any string parameter safely
 */
export const safeParam = (input: string) => input && input.replace(/([^a-z0-9]+)/gi, '');
